<template>
    <v-dialog persistent v-model="localValue" width="1024">
        <v-card tile>
            <v-toolbar color="white">
                <v-toolbar-title class="text-primary">وارد کردن گروهی {{ employee ? 'کاربران سازمانی' : 'مشتریان' }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="localValue = false" icon>
                    <v-icon color="primary" size="23">close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-form @submit.prevent="$refs.form?.isValid ? submit() : ''" class="px-6 pt-3" ref="form">
                <v-row align="center">
                    <v-col cols="12" lg>
                        <p class="text-meta text-grey-darken-2 mb-2 text-justify">برای استفاده از این ویژگی به نکات زیر دقت فرمایید:</p>
                        <ul class="text-meta text-grey-darken-2 ms-5 text-justify mb-lg-5">
                            <li>فایل نمونه را دانلود کرده و اطلاعات {{ employee ? 'کاربران سازمانی' : 'مشتریان' }} را در آن درج نمایید.</li>
                            <li>از حذف ردیف اول خودداری کنید.</li>
                            <li>از عدم وجود داده های تکراری در ستون های نام کاربری، ایمیل و موبایل اطمینان حاصل فرمایید.</li>
                            <li>بسته به تنظیمات انجام شده از سوی شما، تکمیل یکی از ستون های نام کاربری، ایمیل و موبایل الزامی خواهد بود.</li>
                            <li>در ستون جنسیت برای اقایان از حرف m و برای خانم ها از حرف f استفاده کنید.</li>
                            <li>دقت فرمایید که بسته به تعداد ردیف های فایل اکسل ورودی، زمان اتمام عملیات ممکن است متغیر باشد، لذا از ارسال مکرر فایل در این قسمت خودداری نمایید. اتمام عملیات از طریق بخش اعلانات به شما اطلاع رسانی خواهد شد.</li>
                        </ul>
                    </v-col>
                    <v-divider class="mx-5 mb-lg-5 mt-lg-3 ms-lg-0 me-lg-3 d-lg-none"></v-divider>
                    <v-divider class="mx-5 mb-lg-5 mt-lg-3 ms-lg-0 me-lg-3 d-none d-lg-block" vertical></v-divider>
                    <v-col cols="12" lg>
                        <v-radio-group v-model="form.type" class="mt-0" inline hide-details>
                            <v-radio class="ms-0 me-3" label="کلمه عبور یکسان برای همه کاربران" :value="true"></v-radio>
                            <v-radio class="ms-0" label="کلمه عبور برای هر کاربر اختصاصی" :value="false"></v-radio>
                        </v-radio-group>
                        <div class="pa-2 mt-3 mb-9 text-center rounded" style="background-color: #eef7ff; border: 1px solid #2877dc !important">
                            <p v-if="!form.type" class="text-grey-darken-3 mb-0 text-small">دانلود <a href="/import-users-demo.csv" rel="nofollow" target="_blank" class="font-weight-medium">فایل نمونه</a> با کلمه عبور های اختصاصی</p>
                            <p v-else class="text-grey-darken-3 mb-0 text-small">دانلود <a href="/import-users-demo-single-password.csv" rel="nofollow" target="_blank" class="font-weight-medium">فایل نمونه</a> با کلمه عبور یکسان</p>
                        </div>
                        <v-select
                            item-title="name"
                            no-data-text="موردی پیدا نشد!"
                            item-value="id"
                            :rules="$validation('required')"
                            @update:modelValue="(value) => { organizations = $system.organizations.filter(x => x.branch_id == value); form.organization = null}"
                            v-model="form.branch"
                            label="شعبه"
                            :items="$system.branches"
                        ></v-select>
                        <div v-if="this.employee">
                            <v-select
                                item-title="name"
                                no-data-text="موردی پیدا نشد!"
                                item-value="id"
                                :rules="$validation('required')"
                                @update:modelValue="(value) => { workingshifts = departments.find(x => x.id == value).workingshifts; form.workingshifts = [] }"
                                v-model="form.department"
                                label="دپارتمان"
                                :items="departments"
                            ></v-select>
                            <v-select
                                item-title="name"
                                no-data-text="موردی پیدا نشد!"
                                item-value="id"
                                multiple
                                :rules="$validation('required')"
                                :disabled="!form.department"
                                v-model="form.workingshifts"
                                label="شیفت های کاری"
                                :items="workingshifts"
                            ></v-select>
                        </div>
                        <div v-else>
                            <v-select
                                item-title="name"
                                no-data-text="موردی پیدا نشد!"
                                item-value="id"
                                :rules="$validation('required')"
                                @update:modelValue="(value) => form.customer_level = organizations.find(x => x.id == value).customer_level_id"
                                v-model="form.organization"
                                label="سازمان مشتریان"
                                :items="organizations"
                            ></v-select>
                            <v-select
                                item-title="name"
                                no-data-text="موردی پیدا نشد!"
                                :rules="$validation('required')"
                                item-value="id"
                                v-model="form.customer_level"
                                label="سطح مشتریان"
                                :items="$system.customerLevels"
                            ></v-select>
                        </div>
                        <v-text-field
                            v-if="form.type"
                            :rules="$validation('required')"
                            v-model="form.password"
                            label="کلمه عبور کاربران"
                            autocomplete="new-password"
                            :type="pass1 ? 'password' : 'text'"
                        >
                            <template #append-inner>
                                <v-icon v-if="form.password" class="me-2 cursor-pointer" @click="()=>{pass1 = !pass1}">{{ pass1 ? 'visibility' : 'visibility_off' }}</v-icon>
                            </template>
                        </v-text-field>
                        <v-file-input
                            truncate-length="15"
                            :rules="[
                                (v) => !!v || 'تکمیل این فیلد الزامی می باشد',
                                (v) => !v || ['text/csv', 'application/csv', 'application/vnd.ms-excel'].includes(v.type) || 'فایل انتخاب شده حتما باید از نوع CSV باشد',
                                (v) => !form.type || !v || v.size < 5242880 || 'حداکثر حجم مجاز 5MB می باشد',
                                (v) => form.type || !v || v.size < 1048576 || 'حداکثر حجم مجاز 1MB می باشد',
                            ]"
                            v-model="form.excel"
                            show-size
                            label="انتخاب فایل"
                            prepend-inner-icon=""
                            append-inner-icon="$file"
                            accept="text/csv"
                        ></v-file-input>
                    </v-col>
                </v-row>
                <v-card-actions class="py-3 px-5 bg-white">
                    <v-btn color="success" variant="flat" :loading="loading" type="submit">ثبت اطلاعات</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="localValue = false" color="error" variant="text">بستن</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        modelValue: {
            default: null
        },
        employee: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            pass1: true,
            loading: false,
            departments: [],
            workingshifts: [],
            organizations: [],
            form: {
                type: true,
                branch: null,
                organization: null,
                customer_level: null,
                department: null,
                workingshifts: [],
                excel: null,
                password: null,
                employee: this.employee
            },
        };
    },
    computed: {
        localValue: {
            get: function () {return this.modelValue},
            set: function (value) {this.$emit('update:modelValue', value)}
        },
    },
    methods: {
        submit() {
            this.loading = true;
            this.$importUsers(this.$object.toFormData(this.form)).then((res) => {
                if (res && res.status == "OK") {
                    this.localValue = false;
                    this.$toast.success(res.message);
                }
            }).finally(() => this.loading = false);
        },
    },
    async mounted() {
        if (this.employee) {
            await this.$system.setAdminDefaults();
            this.departments = this.$system.departmentsAdmin;
        }
    }
}
</script>
